export default __webpack_public_path__ + "media/katieVid.0361a957.mp4";